import {
  IAddPackingNote,
  IPackingNoteProperties,
  IUpdatePackingNote,
} from "mobx-stores/_models/packing-note/packing-note";
import { BaseBussiness } from "../base";

class PackingNoteBusiness extends BaseBussiness<
  IPackingNoteProperties,
  IAddPackingNote,
  IUpdatePackingNote,
  IPackingNoteProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const packingNoteBusiness = new PackingNoteBusiness(
  "/api/app/packing-note"
);
